
import axios, { getAxiosParams } from "src/lib/axios.config";
import { FlowsApi, UsersApi } from "typescript-axios";
const USERS_API = new UsersApi(getAxiosParams(), undefined, axios);
const FLOWS_API = new FlowsApi(getAxiosParams(), undefined, axios);

export const canCreateNewFlow = async (
  currentNumFlows?: int
): Promise<boolean> => {
  if (currentNumFlows === undefined) {
    currentNumFlows = await FLOWS_API.readMeApiV1FlowsMeGet().then(
      (res) => res.data.length
    );
  }
  return USERS_API.readMeApiV1UsersMeGet()
    .then((res) => {
      let limit = 0;
      if (res.data.current_plan) {
        limit = 5;
      } else if (res.data.is_admin) {
        limit = 100000;
      }
      if (currentNumFlows >= limit) {
        return false;
      }
      return true;
    })
    .catch((err) => {
      console.error(err);
      return false;
    });
};
